const ICON = {
  position: {
    x: 0,
    y: 0
  },
  image: ''
}

export default ICON
